import { defaultKeymap, indentLess, insertTab } from "@codemirror/commands";
import { java } from "@codemirror/lang-java";
import { PostgreSQL, sql } from "@codemirror/lang-sql";
import { xml } from "@codemirror/lang-xml";
import { keymap } from "@codemirror/view";
import { getJavaAnnotationExtension } from "@whilecat/core/editors/extensions/java-annotation-extension.js";

export function getLanguageExtensions(lang) {
    if (lang === "java" || lang == null) {
        return [java(), getJavaAnnotationExtension(), getKeyBindings({ tabEnabled: true })];
    } else if (lang === "xml") {
        return [xml()];
    } else if (lang === "sql") {
        return [sql({ dialect: PostgreSQL })];
    }

    return [];
}

function getKeyBindings(configurations) {
    let keyBindings = defaultKeymap;

    if (configurations.tabEnabled) {
        keyBindings = [
            ...keyBindings,
            {
                key: "Tab",
                preventDefault: true,
                shift: indentLess,
                run: e => {
                    return insertTab(e);
                },
            },
        ];
    }
    return keymap.of(keyBindings);
}
